module.exports = __webpack_public_path__ + "static/img/SC.c55680b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC.jpg
// module id = rwVL
// module chunks = 0